import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import 'animate.css';

import './lunch.scss';

// ここにページの js を記述します
//commonjs
var tabs = require('tabs');

//or directly include the script and 'tabs' will be global

// make it tabbable!
var container = document.querySelector('.tab-container');
tabs(container);

// Slider
const swiper = new Swiper('.swiper', {
  // Optional parameters
  loop: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
});
